const selectSearcher = (input, option) => {
  const label = option?.label ?? option?.name ?? '';
  const cleanedLabel = label.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  return cleanedLabel.toLowerCase().includes(input.toLowerCase());
};

export {
  // eslint-disable-next-line import/prefer-default-export
  selectSearcher,
};
